/**
 * Usage: dateString | smLocalDate:'format'
 **/

import {Pipe, PipeTransform} from '@angular/core';
import {formatDate} from '@angular/common';
import {InternationalizationService} from '@app/core/services/internationalization.service';
import moment from 'moment-timezone/builds/moment-timezone-with-data-1970-2030.min';

@Pipe({
	name: 'smLocalDate',
})
export class LocalDatePipe implements PipeTransform {

	constructor(private interService: InternationalizationService) {
	}

	public transform(value: any, format: string = 'shortDate', fromUTC = false): any {
		if (!value) {
			return '';
		}
		if (typeof value === 'string') {
			value = value.replace(/ /g, 'T');
		}
		if (fromUTC) {
			value = moment.utc(value).tz(this.interService.timezone).toDate();
		}
		return formatDate(value, format, this.interService.currentLocales.angularLocale);
	}
}
